/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import {
  CONVERT_PROJECT_TEMPLATE_REQUEST,
  CONVERT_PROJECT_TEMPLATE_SUCCESS,
  LOAD_PROJECT,
  SET_FILTER,
  SET_PROJECT_ANONYMOUS_ACCESS_KEY,
  SET_PROJECT_NAME,
} from "constants/ActionTypes";
import { Project } from "types/Project";
import { ProjectAction } from "types/Actions";

export default function ProjectReducer(
  project: Project,
  action: ProjectAction
): Project {
  switch (action.type) {
    case LOAD_PROJECT:
      return action.project;
    case SET_PROJECT_NAME:
      return {
        ...project,
        name: action.name,
      };
    case SET_PROJECT_ANONYMOUS_ACCESS_KEY:
      return {
        ...project,
        anonymous_access_key: action.anonymousAccessKey,
      };
    case SET_FILTER:
      return {
        ...project,
        filters: {
          ...project.filters,
          [action.filterName]: {
            enabled: action.enabled,
            strengthPercent: action.strengthPercent,
          },
        },
      };
    case CONVERT_PROJECT_TEMPLATE_REQUEST:
      return {
        ...project,
        is_template: "pending",
      };
    case CONVERT_PROJECT_TEMPLATE_SUCCESS:
      return {
        ...project,
        is_template: true,
      };
    default:
      return project;
  }
}
